import React, { useEffect, useState } from "react";
import { DashboardLayout, FormParser,PopupModal } from "../Components";
import { NavLink,useParams } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"
const TariffTypeEdit = () => {
    const[popupType,setpopupType]=useState("")
    const[Error,SetError]=useState("")
    const MastersModal=Masters.TariffType
    const formSubmit=(Data)=>{
        axiosConfig.put(`/masters/tarifftype/${id}/`,Data).then(res=>{
                   console.log(res)
                   setpopupType("success")
        }).catch(error=>{
            console.log(error)
            const ErrorData=[]
            ErrorData.push({
                tarifftype_code:error.response.data.tarifftype_code||["null"],
                    })
                    console.log(ErrorData[0])
            if(ErrorData[0].tarifftype_code[0]==="tariff type with this tarifftype code already exists."){
                SetError("Code Already Exists")
            }
            setpopupType("error")
        })
      }
    let { id } = useParams();
    const [Data, SetData] = useState([])
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get(`/masters/tarifftype/${id}/`)
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
        }

    }
    useEffect(() => {
        GetData();
    }, [])
    return (
        <>
            <DashboardLayout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">Edit TariffType {id}</h5>
                    <NavLink to="/dashboard/masters/tarifftype" ><button className="btn btn-white">Manage</button></NavLink>
                </div>
                <FormParser modelObject={MastersModal} formData={Data} formSubmit={formSubmit} error={Error}/>
                {popupType != "" &&
                    <PopupModal popupType={popupType} Navigation="/dashboard/masters/tarifftype" />
                }
            </DashboardLayout>
        </>
    )

}
export {TariffTypeEdit}